$(document).ready(function () {
    // NAV - Switcher lang
    //----------------------------------//
    $("#languages_dropdown").click(function () {
        $(this).parent().toggleClass("active");
    });

    // NAV - MOBILE ASIDE MENU
    //----------------------------------//
    if ($(window).width() < 901) {
        $(".burger_nav, .close_menu, .overlay").click(function () {
            $(".main_nav, .overlay").toggleClass("active");
            $("body").toggleClass("noscroll");
        });
    }

    // NAV - CART
    //----------------------------------//

    $(document).on("click", ".cart_box", function (e) {
        e.stopPropagation();
    });

    $(document).on("click", function () {
        if ($(".cart_links .cart").hasClass("open")) {
            if ($(window).width() > 900) {
                $(".cart_links .cart").removeClass("open");
                $(".overlay_menu").removeClass("open");
            }
        }
    });

    $(document).on("click", ".cart_links .cart", function (e) {
        if ($(window).width() > 900) {
            e.stopPropagation();
            $(this).toggleClass("open");
            $(".overlay_menu").toggleClass("open");
        }
    });

    // NAV - ACCOUNT
    //----------------------------------//
    $(".cart_links .account").click(function () {
        $(this).toggleClass("open");
        $(".overlay_menu").toggleClass("open");
    });

    function toggle_modal_connexion() {
        $(".open_modal_connexion").on("click", function (e) {
            e.preventDefault();

            $("body").removeClass("show_modal_account show_modal_password noscroll");
            $("body").addClass("show_modal_connexion noscroll");
        });

        function close_modal_connexion() {
            $("body").removeClass("show_modal_connexion noscroll");
        }

        $("body").on("click", ".modal_connexion .close_modal, .modal_connexion .overlay2", function (e) {
            e.preventDefault();
            close_modal_connexion();
        });

        $("body").keyup(function (e) {
            e.preventDefault();

            if (e.keyCode == 27) {
                close_modal_connexion();
            }
        });
    }
    toggle_modal_connexion();

    function toggle_modal_account() {
        $(".open_modal_account").on("click", function (e) {
            e.preventDefault();

            $("body").removeClass("show_modal_connexion show_modal_password noscroll");
            $("body").addClass("show_modal_account noscroll");
        });

        function close_modal_account() {
            $("body").removeClass("show_modal_account noscroll");
        }

        $("body").on("click", ".modal_account .close_modal, .modal_account .overlay2", function (e) {
            e.preventDefault();
            close_modal_account();
        });

        $("body").keyup(function (e) {
            e.preventDefault();

            if (e.keyCode == 27) {
                close_modal_account();
            }
        });
    }
    toggle_modal_account();

    function toggle_modal_password() {
        $(".open_modal_password").on("click", function (e) {
            e.preventDefault();

            $("body").removeClass("show_modal_connexion show_modal_account noscroll");
            $("body").addClass("show_modal_password noscroll");
        });

        function close_modal_password() {
            $("body").removeClass("show_modal_password noscroll");
        }

        $("body").on("click", ".modal_password .close_modal, .modal_password .overlay2", function (e) {
            e.preventDefault();
            close_modal_password();
        });

        $("body").keyup(function (e) {
            e.preventDefault();

            if (e.keyCode == 27) {
                close_modal_password();
            }
        });
    }
    toggle_modal_password();

    $(document).mouseup(function (e) {
        // NAV - Switcher lang
        //----------------------------------//
        var switcherLang = $("#languages_dropdown");
        if (!switcherLang.is(e.target) && switcherLang.has(e.target).length === 0) {
            switcherLang.parent().removeClass("active");
        }
    });

    $(window).scroll(function () {
        // Fixed nav on scroll
        if ($(window).scrollTop() > 50) {
            $("nav").addClass("sticky");
        } else {
            $("nav").removeClass("sticky");
        }
    });

    if ($("nav") && $(".sousMenu-boutique")) {
        $(window).scroll(function () {
            if ($(window).scrollTop() > 50) {
                $(".sousMenu-boutique").addClass("show");

                if ($("nav").hasClass("add_banner")) {
                    var navHeight = $('.add_banner').outerHeight();
        
                    $(window).scroll(function () {
                        $(".sousMenu-boutique").css("top", navHeight);
                    });
                }
            } else {
                $(".sousMenu-boutique").removeClass("show");
            }
        }); 
    }

    const links = document.querySelectorAll(".sousMenu-boutique a");
    const sections = document.querySelectorAll(".forJS");

    function changeLinkState() {
        let index = sections.length;

        while (--index && window.scrollY + 350 < sections[index].offsetTop) {}

        links.forEach((link) => link.classList.remove("active"));

        // add the active class if within visible height of the element
        if (scrollY - sections[index].offsetHeight < sections[index].offsetTop) {
            links[index].classList.add("active");
        }
    }

    changeLinkState();
    window.addEventListener("scroll", changeLinkState);
});
